import { PaymentResultProps } from './types';

export const PAYMENT_MESSAGES = {
  success: {
    title: 'Payment Successful!',
    subtitle: 'Congratulations! You\'ve successfully purchased',
    toast: 'Payment successful!'
  },
  failure: {
    title: 'Payment Failed',
    subtitle: 'We couldn\'t process your payment for',
    toast: 'Payment failed. Please try again.'
  },
  cancelled: {
    title: 'Payment Cancelled',
    subtitle: 'Your payment for',
    toast: 'Payment was cancelled. No amount was charged.'
  }
};

// Preset configurations for different payment scenarios
export const PAYMENT_RESULT_PRESETS = {
  selfcareSuccess: {
    paymentStatus: 'success' as const,
    showNextSteps: true,
    nextStepsContent: [], // Will be overridden by service-specific content
    showFAQ: false,
    toastMessage: PAYMENT_MESSAGES.success.toast,
    loadingTimeout: 10000
  },
  selfcareFailure: {
    paymentStatus: 'failure' as const,
    showNextSteps: false,
    showFAQ: true,
    faqData: [], // Will be overridden by service-specific content
    toastMessage: PAYMENT_MESSAGES.failure.toast,
    loadingTimeout: 5000
  },
  selfcareCancelled: {
    paymentStatus: 'cancelled' as const,
    showNextSteps: false,
    showFAQ: false,
    toastMessage: PAYMENT_MESSAGES.cancelled.toast,
    loadingTimeout: 5000
  },
  courseSuccess: {
    paymentStatus: 'success' as const,
    showNextSteps: false,
    showFAQ: false,
    toastMessage: PAYMENT_MESSAGES.success.toast,
    loadingTimeout: 10000
  },
  courseFailure: {
    paymentStatus: 'failure' as const,
    showNextSteps: false,
    showFAQ: false,
    toastMessage: PAYMENT_MESSAGES.failure.toast,
    loadingTimeout: 5000
  },
  courseCancelled: {
    paymentStatus: 'cancelled' as const,
    showNextSteps: false,
    showFAQ: false,
    toastMessage: PAYMENT_MESSAGES.cancelled.toast,
    loadingTimeout: 5000
  }
};

// Helper function to get message text based on status
export const getPaymentMessage = (status: 'success' | 'failure' | 'cancelled') => {
  return PAYMENT_MESSAGES[status];
};

// Helper function to merge preset with custom props
export const createPaymentResultProps = (
  presetKey: keyof typeof PAYMENT_RESULT_PRESETS,
  customProps: Partial<PaymentResultProps>
): PaymentResultProps => {
  const preset = PAYMENT_RESULT_PRESETS[presetKey];
  
  return {
    ...preset,
    ...customProps,
    // Ensure required props have defaults
    retryPath: customProps.retryPath || '/student-selfcare-details',
    dashboardPath: customProps.dashboardPath || '/student-selfcare'
  };
};